var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.125C13.6624 0.125 10.3998 1.1147 7.62476 2.96895C4.84968 4.8232 2.68677 7.45871 1.40954 10.5422C0.132312 13.6257 -0.20187 17.0187 0.449256 20.2921C1.10038 23.5656 2.70757 26.5724 5.06758 28.9324C7.42759 31.2924 10.4344 32.8996 13.7079 33.5508C16.9813 34.2019 20.3743 33.8677 23.4578 32.5905C26.5413 31.3132 29.1768 29.1503 31.0311 26.3752C32.8853 23.6002 33.875 20.3376 33.875 17C33.87 12.526 32.0906 8.23666 28.927 5.07305C25.7634 1.90945 21.474 0.129963 17 0.125ZM22 13.875V20.125C22 20.6223 21.8025 21.0992 21.4508 21.4508C21.0992 21.8025 20.6223 22 20.125 22H13.875C13.3777 22 12.9008 21.8025 12.5492 21.4508C12.1976 21.0992 12 20.6223 12 20.125V13.875C12 13.3777 12.1976 12.9008 12.5492 12.5492C12.9008 12.1975 13.3777 12 13.875 12H20.125C20.6223 12 21.0992 12.1975 21.4508 12.5492C21.8025 12.9008 22 13.3777 22 13.875Z",
    fill: "#D30405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.fee351b72c704f3eedcdb4424f81a16f.svg";
export { ForwardRef as ReactComponent };